(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('multiSelect', multiSelect);

    multiSelect.$inject = ['$filter', '$timeout', 'modals', '$state'];

    function multiSelect($filter, $timeout, modals, $state) {

        var directive = {
            link: link,
            require: ['?^form','ngModel'],
            restrict: 'EA',
            templateUrl: 'app/views/directives/multiSelect.html',
            scope: {
                data: '=', //List of elements
                ngModel: '=', //Item selected
                idField: '@?', //Default: 'id'
                displayField: '@?', //Default: 'nombre'
                displayIdField: '@?',
                displayExtraField: '@?',
                labelText: '@?',
                isLoading: '=?', //Expression to display the loading message
                loadingText: '@?', //Default: 'Cargando datos...'
                emptyText: '@?', //Default: 'No hay elementos'
                ngChange: '&?', //Callback function when ngModel changes
                ngDisabled: '=?',
                autofocus: '<',
                placeholder: '@?',
            }
        };
        return directive;

        function link(scope, element, attrs, ctrls) {

            var mainElement = element[0].children[1];
            
            scope.ngModel = [];
            scope.isOpen = false;
            scope.filter = { text: '' };

            if(!scope.idField){ scope.idField = 'id'; }
            if(!scope.displayField){ scope.displayField = 'nombre'; }
            if(!scope.loadingText){ scope.loadingText = 'Cargando datos...'; }
            if(!scope.emptyText){ scope.emptyText = 'No hay elementos'; }
            if(!scope.placeholder){ scope.placeholder = ''; }
            if(!scope.autofocus){ scope.autofocus = false; } else { scope.autofocus = true;}

            scope.emptyItem = {};
            scope.emptyItem[scope.idField] = null;
            scope.emptyItem[scope.displayField] = null;
            scope.emptyItem[scope.displayIdField] = null;

            scope.selectItem = function (item) {
                $timeout(function(){
                    if(item){
                        scope.ngModel.push(item);
                        if(ctrls[0]){ ctrls[0].$dirty = true; }
                        if(ctrls[1]){ ctrls[1].$dirty = true; }
                    }
                });

                if (scope.highlighted === item) {
                    var data = $filter('filter')(scope.data, scope.isNotSelected);
                    if(data.length > 0){
                        scope.highlighted = data[0];
                    }else{
                        scope.highlighted = null;
                    }
                }
            };

            scope.removeItem = function (item) {
                if(scope.ngDisabled) { return; }
                
                var index = scope.ngModel.indexOf(item);
                if (index > -1) { 
                    scope.ngModel.splice(index, 1);
                    if(ctrls[0]){ ctrls[0].$dirty = true; }
                    if(ctrls[1]){ ctrls[1].$dirty = true; }
                    if(!scope.highlighted){
                        var data = $filter('filter')(scope.data, scope.isNotSelected);
                        scope.highlighted = data[0];
                    }
                }
            };

            scope.isSelected = function (item) {
                var id = scope.idField + '';
                var result = $filter('filter')(scope.ngModel, { id: item[scope.idField] });
                return result.length > 0;
            };

            scope.isNotSelected = function (item) {
                if(!scope.ngModel){return true;}
                var id = scope.idField + '';
                var result = $filter('filter')(scope.ngModel, { id: item[scope.idField] });
                return result.length <= 0;
            };

            /**
             * Setting listeners to close when the main element lose focus
             */
            $timeout(function () {
                mainElement.addEventListener('focus',focusEvent,true);
                mainElement.addEventListener('blur',blurEvent,true);
            });

            element.on('keydown', 
                function (evt) {
                    /* jshint maxcomplexity:false */
                    var index = 0;
                    switch(evt.keyCode){
                        case 40: //ARROW DOWN
                            evt.preventDefault();
                            if(!scope.isOpen){ open(); }
                            else if(scope.filteredList){
                                if(scope.highlightItem){
                                    index = indexOfById(scope.highlightItem);
                                    if(index < scope.filteredList.length-1){
                                        index++;
                                    }
                                }
                                highlightIndex(index);
                            }
                            break;

                        case 38: //ARROW UP
                            evt.preventDefault();
                            if(!scope.isOpen){ open(); }
                            else if(scope.filteredList){
                                if(scope.highlightItem){
                                    index = indexOfById(scope.highlightItem);
                                    if(index > 0){
                                        index--; 
                                    }
                                }
                                highlightIndex(index);
                            }
                            break;
                        
                        case 13: //ENTER
                            if(scope.highlightItem){ scope.selectItem(scope.highlightItem); }
                            break;
                            
                        case 9: //TAB
                            //if(scope.highlightItem){ scope.selectItem(scope.highlightItem); }
                            break;
                    }
                    scope.$apply();
                }
            );

            scope.$watch('data.length',
                scope.filterData
            );

            /**
             * Watching the selected item:
             *  - ngChange callback
             */
            scope.$watch(
                'ngModel',
                function (newSelected, oldSelected) {
                    /* jshint maxcomplexity:false */
                    var equal = true;
                    var newData = [];
                    angular.forEach(newSelected, function(value, key) {
                        var index = indexOfById(value, scope.data);
                        equal = equal && indexOfById(value, oldSelected) >= 0;
                        if(index < 0 && !scope.isLoading){
                            scope.ngModel = oldSelected;
                            return;
                        } else {
                            newData.push(scope.data[index]);
                        }
                    });

                    scope.ngModel = newData;
                    
                    if(newSelected.length === oldSelected.length && equal){
                        return;
                    }

                    if (scope.ngChange) {
                        scope.ngChange(); //Calling ngChange callback
                    }
                },
                true
            );

            scope.filterData = function(){
                if(!scope.data) { return; }
                //Filtered data by name
                var filterInfo = {};
                filterInfo[scope.displayField] = scope.filter.text;
                if(scope.displayIdField){
                    filterInfo[scope.displayIdField] = scope.filter.text;
                }
                if(scope.displayExtraField){
                    filterInfo[scope.displayExtraField] = scope.filter.text;
                }
                scope.filteredList = $filter('searchFilter')(scope.data, filterInfo, true);

                highlightIndex(0);
            };

            scope.toggleOpen = function(){
                if(scope.ngDisabled) { return; }

                if(scope.isOpen){ close(); }
                else { open(); }
            };

            scope.clickElement =  function(item){
                scope.keepOpen = true;
                scope.selectItem(item);
                //console.log('Element clicked: keepOpen -> ' + scope.keepOpen);
                mainElement.focus();
            };

            /* Private functions */
            function focusEvent(){
                scope.keepOpen = true;
                //$timeout(function(){
                //    $timeout(function(){
                //    scope.keepOpen = false;
                //    });
                //});
            }
            function blurEvent(){
                $timeout(function(){
                    //console.log('BLUR EVENT: keep open -> ' + scope.keepOpen);
                    if(!scope.keepOpen){
                        close();
                    }else{
                        scope.keepOpen = false;
                        mainElement.focus();
                    }
                });
            }
            function highlightIndex(index){
                scope.highlightItem = scope.filteredList[index];
                moveListTo(index);
            }
            function open(){
                if(scope.ngDisabled) { return; }

                scope.isOpen = true;

                //Timeout to wait for the DOM to render
                $timeout( function () { //Render the div
                    if(scope.isOpen){
                        element[0].querySelectorAll('input')[0].focus();
                        scope.filterData();
                    }
                });
            }
            function close(){
                scope.isOpen = false;
                scope.filter.text = '';
            } 
            function moveListTo(i){
                var index = i+1;
                var list = element.find('ul')[0];
                if(!list || !list.children || list.children.length <= 0) { return; }
                if(index < 0 || index >= list.children.length){ return; }

                var item = list.children[index];

                //If we need to scroll up to find the item
                if(item.offsetTop < list.scrollTop){
                    list.scrollTop = item.offsetTop;
                }

                //If we need to scroll down to find the item
                if(item.offsetTop + item.offsetHeight > list.scrollTop + list.clientHeight){
                    list.scrollTop = item.offsetTop + item.offsetHeight - list.clientHeight;
                }
            }
            function indexOfById(item, list){

                if(!list) { list = scope.filteredList; }
                if(!list) {return -1;}
                var value = item[scope.idField];
                for(var i = 0; i < list.length; i += 1) {
                    if(list[i][scope.idField] === value) {
                        return i;
                    }
                }
                return -1;
            }

            scope.$on('$destroy', function() {
                mainElement.removeEventListener('focus',focusEvent,true);
                mainElement.removeEventListener('blur',blurEvent,true);
            });
        }
    }
})();